module.exports = __webpack_public_path__ + "img/2D-building-envelope.05f3c649.svg";